import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=1eeaed81&scoped=true&"
import script from "./terms-of-use.vue?vue&type=script&lang=js&"
export * from "./terms-of-use.vue?vue&type=script&lang=js&"
import style0 from "./terms-of-use.vue?vue&type=style&index=0&id=1eeaed81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeaed81",
  null
  
)

component.options.__file = "terms-of-use.vue"
export default component.exports